import { getCoreDataDictionarySearchSlice } from './get';

export const { requestGetCoreDataDictionarySearch, resetGetCoreDataDictionarySearch } =
	getCoreDataDictionarySearchSlice.asyncActionCreators;
